<template>

  <sc-dropdown-item class="card-dropdown-item" :disabled="this.app.schemaBased !== null || this.app.status === 'UNINSTALLED'"
    @click="() => handleEditIntegrationButton()">
    <span>
      <sc-icon icon="pen"></sc-icon> Editar
    </span>
  </sc-dropdown-item>

</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScIcon,
  ScDropdownItem,
} from "@intelipost-js/secure-components";

const { mapActions } = createNamespacedHelpers("integrations/integrationsHome");

export default {
  name: "iplink-app-card-header-menu",

  props: {
    app: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions([
      "selectAppAction",
      "showEditModalAction"
    ]),

    handleEditIntegrationButton() {
      this.selectAppAction(this.app)
      this.showEditModalAction(true);
    },

  },

  components: {
    ScIcon,
    ScDropdownItem,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-list/app-card/header-card/menu-card/edit-button/EditButton.vue?94588d78